// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: cases_analytics.proto

import type { MetricWithPrior } from './analytics';

export const protobufPackage = 'compasspb';

/** Request filters only; responses use string group keys (as QC: call_directions enum in, direction string out). */
export enum CaseReportType {
  CASE_REPORT_TYPE_UNSPECIFIED = 0,
  CASE_REPORT_TYPE_AE = 1,
  CASE_REPORT_TYPE_PQC = 2,
}

export enum CaseSlaStatus {
  CASE_SLA_STATUS_UNSPECIFIED = 0,
  CASE_SLA_STATUS_WITHIN = 1,
  CASE_SLA_STATUS_BREACHED = 2,
}

export interface GetCasesAnalyticsRequest {
  organization_id?: string | undefined;
  /** empty = all programs in the caller's scope; max 100 */
  program_ids?: string[] | undefined;
  /** empty = all; UNSPECIFIED rejected */
  report_types?: CaseReportType[] | undefined;
  /** RFC3339, required; cases created in [start, end); span <= 366 days */
  start?: string | undefined;
  /** RFC3339, required */
  end?: string | undefined;
  /** RFC3339 UTC, ascending, [0] <= start, <= 120 */
  trend_bucket_starts?: string[] | undefined;
  /** ascending, [0] = 0, <= 20; e.g. [0, 6, 12, 18, 24, 36, 48] */
  time_to_submit_bucket_starts_hours?: number[] | undefined;
  /** SLA status dropdown; UNSPECIFIED = all cases */
  sla_status?: CaseSlaStatus | undefined;
}

export interface GetCasesAnalyticsResponse {
  /** KPI cards and the SLA status dropdown counts */
  summary?: CasesAnalyticsSummary | undefined;
  /** "day" | "week" | "month", as QC */
  trend_bucket?: string | undefined;
  /** "Cases submitted over time" */
  submitted_trend?: CasesSubmittedTrend | undefined;
  /** "SLA compliance over time" */
  sla_compliance_trend?: SlaComplianceTrendPoint[] | undefined;
  /** "Case breakdown" donuts */
  breakdown?: CasesBreakdown | undefined;
  /** "How long cases took to submit" */
  time_to_submit?: TimeToSubmit | undefined;
  /** "Time spent at each step" */
  time_by_step?: CasesTimeByStep | undefined;
  /** strip shown when the SLA filter is Breached */
  breached_summary?: CasesBreachedSummary | undefined;
}

/** KPI cards. prior_value = the previous range of the same length. */
export interface CasesAnalyticsSummary {
  submitted_cases?: MetricWithPrior | undefined;
  within_sla_cases?: MetricWithPrior | undefined;
  breached_cases?: MetricWithPrior | undefined;
}

/**
 * One list per chart toggle. group keys: report type "ae" | "pqc"; program: program_id;
 * method: "email" | "portal" | "warm_transfer".
 */
export interface CasesSubmittedTrend {
  /** "By type" */
  by_report_type?: CasesTrendPoint[] | undefined;
  /** "By program" */
  by_program?: CasesTrendPoint[] | undefined;
  /** "By method" */
  by_submission_method?: CasesTrendPoint[] | undefined;
}

export interface CasesTrendPoint {
  /** bucket start, RFC3339, as sent in trend_bucket_starts */
  date?: string | undefined;
  group?: string | undefined;
  /** "PQC", "Pfizer", "Warm transfer" */
  group_name?: string | undefined;
  case_count?: number | undefined;
}

/** Same shape as QC's ComplianceTrendPoint. group: "overall" or a program_id. */
export interface SlaComplianceTrendPoint {
  date?: string | undefined;
  group?: string | undefined;
  /** "Overall" or the program name */
  group_name?: string | undefined;
  /** within_sla_count / total_count */
  rate?: number | undefined;
  within_sla_count?: number | undefined;
  total_count?: number | undefined;
}

export interface CasesBreakdown {
  /** the number in the donut centre */
  total?: number | undefined;
  by_program?: CasesBreakdownEntry[] | undefined;
  by_submission_method?: CasesBreakdownEntry[] | undefined;
  by_report_type?: CasesBreakdownEntry[] | undefined;
}

export interface CasesBreakdownEntry {
  group?: string | undefined;
  group_name?: string | undefined;
  case_count?: number | undefined;
}

/** Same toggles as CasesSubmittedTrend. */
export interface TimeToSubmit {
  by_report_type?: TimeToSubmitPoint[] | undefined;
  by_program?: TimeToSubmitPoint[] | undefined;
  by_submission_method?: TimeToSubmitPoint[] | undefined;
}

export interface TimeToSubmitPoint {
  /** as sent in time_to_submit_bucket_starts_hours */
  bucket_start_hours?: number | undefined;
  group?: string | undefined;
  group_name?: string | undefined;
  case_count?: number | undefined;
}

/** step keys: "call_received" | "intake_unassigned" | "intake_assigned" | "review". */
export interface CasesTimeByStep {
  /** the Summary tab: one row per step and segment */
  summary?: StepTime[] | undefined;
  /** the Over time tab: one row per bucket and step */
  trend?: StepTimePoint[] | undefined;
}

export interface StepTime {
  step?: string | undefined;
  /** "all" | "within_sla" | "breached" */
  segment?: string | undefined;
  avg_seconds?: number | undefined;
  case_count?: number | undefined;
}

export interface StepTimePoint {
  date?: string | undefined;
  step?: string | undefined;
  avg_seconds?: number | undefined;
  case_count?: number | undefined;
}

export interface CasesBreachedSummary {
  /** average of (time to submit − the workflow's SLA budget), breached cases */
  avg_seconds_past_sla?: number | undefined;
  /** longest time to submit among breached cases */
  longest_submit_seconds?: number | undefined;
}

/**
 * CasesAnalyticsService serves the AE/PQC Analytics page: aggregate counts and
 * times over completed AE/PQC cases, from ClickHouse (analytics.aepqc_case_events).
 * HTTP only, like AnalyticsService. The response carries ids, program names and
 * counts only; no case data.
 */
export interface CasesAnalyticsService {
  /** GET /api/v1/organizations/{organization_id}/cases-analytics */
  getCasesAnalytics(request: GetCasesAnalyticsRequest): Promise<GetCasesAnalyticsResponse>;
}
